// extracted by mini-css-extract-plugin
export default {"mobile":"iUSaT","root":"fWiPc","onImage":"_2OY+L"};